import Flex from '@creditflowresearch/uilib/Flex';
import { useUserPlanPreferences } from '@/creditflowresearch/application/hooks/userPreferences/useUserPlanPreferences';
import { IBasePreferenceItem } from '@/creditflowresearch/application/hooks/userPreferences/helpers';
import PreferenceBadgeButton from './PreferenceBadgeButton';

import styles from './userPreferences.module.scss';

interface IUserPreferencesProps {
  isMobile?: boolean,
}

const UserPreferences = ({
  isMobile = false,
}: IUserPreferencesProps) => {
  const {
    items,
    currentChildren,
    segmentItems,
    preferences,
    addNewItemPreference,
    isFetching,
    canAccess,
    canActive,
  } = useUserPlanPreferences();

  if (!preferences) {
    return null;
  }

  const renderBadgeGroup = (
    items: IBasePreferenceItem[],
    onClick: (item: IBasePreferenceItem) => void,
  ) => (
    <Flex className={ styles.productsAndRegionsContainer } wrap="wrap">
      { items.map((item) => (
        <PreferenceBadgeButton
          key={ item.id }
          item={ item }
          isFetching={ isFetching }
          onClick={ onClick }
          isMobile={ isMobile }
          isActive={ canActive(item) }
          isDisabled={ !canAccess(item) }
        />
      )) }
    </Flex>
  );

  return (
    <Flex className={ styles.section } dataTest="userPreferencesDesktop">
      <p className={ styles.productsAndRegionsTitle }>Manage your default page:</p>

      <Flex direction="column" gap={ 10 }>
        { renderBadgeGroup(items, addNewItemPreference) }
        { renderBadgeGroup(currentChildren, addNewItemPreference) }
        { !!segmentItems.length && renderBadgeGroup(segmentItems, addNewItemPreference) }
      </Flex>

      {
        isMobile && (
        <p className={ styles.productsAndRegionsHint }>
          Set default product and region. This will determine the page you land on at login.
        </p>
        )
      }
    </Flex>
  );
};

export default UserPreferences;
